<template>
    <div class="btn-my-account  p-2 text-2xl inline cursor-pointer" @click="toggleMyAccount()">
        my account
    </div>
</template>

<script>
    export default {
        name: "BtnMyAccount",
        methods:{
            toggleMyAccount(){
                // $eventbus.$emit('open:my-account');
                $eventbus.$emit('toggle:my-account');
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>